import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HistoryGuard implements CanActivate {

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const userStr = sessionStorage.getItem('user');
    if (!userStr) return false;
    
    try {
      const userProfile = JSON.parse(userStr);
      return !!(userProfile?.security?.historyTab);
    } catch (error) {
      console.error('Error parsing user profile:', error);
      return false;
    }
  }
}